"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODULE_PATH = void 0;
var MODULE_PATH = 'email-service-provider';
exports.MODULE_PATH = MODULE_PATH;